import { AppStateEnum } from '../../../main/types/app-state.types.ts';
import { getReduxStoreUtil } from '../../../main/utils/redux-store.util.ts';

import { selectCurrentAttemptDescription } from '../../selectors/current-attempt-description.selector.ts';
import { registerAttempt, resetActivityTrackingSlice } from '../../slices/activity-tracking/activity-tracking.slice.ts';
import { Attempt } from '../../slices/activity-tracking/activity-tracking.slice.types.ts';

import { getEncouragementUtil } from './encouragement.util.ts';

export class ActivityTrackingUtil {
  private static _instance: ActivityTrackingUtil;

  private constructor(
    private readonly encouragementUtil = getEncouragementUtil(),
    private readonly reduxStoreUtil = getReduxStoreUtil()
  ) {}

  public static get instance(): ActivityTrackingUtil {
    if (!ActivityTrackingUtil._instance) {
      ActivityTrackingUtil._instance = new ActivityTrackingUtil();
    }
    return ActivityTrackingUtil._instance;
  }

  public async handleAppStateChange(state: AppStateEnum): Promise<void> {
    switch (state) {
      case AppStateEnum.Correct:
      case AppStateEnum.Incorrect:
        await this.trackAttempt(state === AppStateEnum.Correct);
        break;
    }
  }

  private async trackAttempt(isCorrect: boolean): Promise<void> {
    const dispatch = await this.reduxStoreUtil.getDispatch();
    const attempt = await this.createAttempt(isCorrect);
    dispatch(registerAttempt(attempt));

    const shouldGiveEncouragement = await this.encouragementUtil.shouldGiveEncouragement();
    if (shouldGiveEncouragement) {
      await this.encouragementUtil.queueEncouragement();
      dispatch(resetActivityTrackingSlice());
    }
  }

  private async createAttempt(isCorrect: boolean): Promise<Attempt> {
    const state = await this.reduxStoreUtil.getRootState();
    const description = selectCurrentAttemptDescription(state);
    return {
      isCorrect,
      description,
    };
  }
}

export const getActivityTrackingUtil = (): ActivityTrackingUtil => ActivityTrackingUtil.instance;
